import { PatientControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author Shrinivas Mandhare
 */
export const useChangePatientStatus = () =>
  useMutationWithLoading(
    async (params: {
      patientId: string;
      status: boolean;
      xTENANTID?: string;
    }) =>
      new PatientControllerApi(getConfigObject()).updatePatientStatus(
        params?.patientId,
        params?.status,
        params?.xTENANTID
      )
  );
